<template>
  <q-tree ref="componentRef" v-bind="$attrs">
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </q-tree>
</template>

<script setup>
import { useTemplateRef } from "vue";

const componentRef = useTemplateRef("componentRef");

defineExpose({
  componentRef,
});
</script>

<style lang="scss">
.q-tree {
  @apply tw-text-slate-300;
}
</style>
